import { styled } from '@mui/material';

export const OuterWrapper = styled('div')(({ theme, backgroundColor }) => ({
  backgroundColor: backgroundColor || theme.colors.background,
}));
